export const rowsChart = [
    // 9 ghế VIP hàng thứ ba
    // {labelRow: "VIPc",
    //   coordinates: [
    //       { cx: 1071.129, cy: 272.36 },
    //       { cx: 1156.733, cy: 272.36 },
    //       { cx: 1242.336, cy: 272.36 },
    //       { cx: 1327.94, cy: 272.36 },
    //       { cx: 1413.544, cy: 272.36 },
    //       { cx: 1499.147, cy: 272.36 },
    //       { cx: 1584.751, cy: 272.36 },
    //       { cx: 1670.354, cy: 272.36 },
    //       { cx: 1755.958, cy: 272.36 }
    // ]},
    // 8 ghế VIP hàng thứ hai
    {labelRow: "VIPb",
      coordinates: [
          { cx: 1071.129, cy: 362.824  },
          { cx: 1168.962, cy: 362.824  },
          { cx: 1266.794, cy: 362.824  },
          { cx: 1364.627, cy: 362.824  },
          { cx: 1462.46, cy: 362.824  },
          { cx: 1560.293, cy: 362.824  },
          { cx: 1658.125, cy: 362.824  },
          { cx: 1755.958, cy: 362.824  }
    ]},
    // 7 ghế VIP hàng đầu tiên -> 6
    {labelRow: "VIPa",
      coordinates: [
          { cx: 1149.714, cy: 452.169  },
          { cx: 1256.484, cy: 452.169  },
          { cx: 1363.253, cy: 452.169  },
          { cx: 1470.023, cy: 452.169  },
          { cx: 1576.792, cy: 452.169  },
          // { cx: 1238.689, cy: 452.169  },
          // { cx: 1327.663, cy: 452.169  },
          // { cx: 1416.638, cy: 452.169  },
          // { cx: 1505.612, cy: 452.169  },
          // { cx: 1594.587, cy: 452.169  },
          { cx: 1683.562, cy: 452.169  }
    ]},
     // 5 ghế thư ký
    {labelRow: "SE",
      coordinates: [
        // {cx: 918.804, cy: 601.313  },
        {cx: 874.916, cy: 619.032  },
        {cx: 831.029, cy: 636.75  },
        {cx: 787.142, cy: 654.47  },
        // {cx: 743.254, cy: 672.188  }
    ]},
    //row C,
    {
      labelRow: "C",
      coordinates: [
        {cx: 2247.403, cy: 976.4 },
        {cx: 2222.063, cy: 989.28 },
        {cx: 2196.594, cy: 1001.75 },
        {cx: 2171.014, cy: 1013.82 },
        {cx: 2145.313, cy: 1025.47 },
        {cx: 2119.483, cy: 1036.71 },
        {cx: 2093.543, cy: 1047.53 },
        {cx: 2067.474, cy: 1057.94 },
        {cx: 2041.283, cy: 1067.94 },
        {cx: 2014.974, cy: 1077.51 },
        {cx: 1988.543, cy: 1086.67 },
        {cx: 1961.983, cy: 1095.42 },
        {cx: 1935.304, cy: 1103.74 },
        {cx: 1908.493, cy: 1111.64 },
        {cx: 1881.573, cy: 1119.12 },
        {cx: 1854.523, cy: 1126.19 },
        {cx: 1827.344, cy: 1132.82 },
        {cx: 1800.043, cy: 1139.04 },
        {cx: 1772.623, cy: 1144.83 },
        {cx: 1745.073, cy: 1150.19 },
        {cx: 1717.394, cy: 1155.13 },
        {cx: 1689.594, cy: 1159.64 },
        {cx: 1661.043, cy: 1163.73 },
        {cx: 1576.844, cy: 1173.37 },
        {cx: 1547.354, cy: 1175.84 },
        {cx: 1517.873, cy: 1177.81 },
        {cx: 1488.384, cy: 1179.29 },
        {cx: 1458.894, cy: 1180.27 },
        {cx: 1429.403, cy: 1180.76 },
        {cx: 1399.903, cy: 1180.76 },
        {cx: 1370.414, cy: 1180.27 },
        {cx: 1340.924, cy: 1179.28 },
        {cx: 1311.424, cy: 1177.8 },
        {cx: 1281.934, cy: 1175.83 },
        {cx: 1252.443, cy: 1173.37 },
        {cx: 1168.374, cy: 1163.73 },
        {cx: 1140.454, cy: 1159.64 },
        {cx: 1112.653, cy: 1155.13 },
        {cx: 1084.974, cy: 1150.19 },
        {cx: 1057.424, cy: 1144.83 },
        {cx: 1030.003, cy: 1139.04 },
        {cx: 1002.704, cy: 1132.82 },
        {cx: 975.523, cy: 1126.19 },
        {cx: 948.474, cy: 1119.12 },
        {cx: 921.543, cy: 1111.64 },
        {cx: 894.744, cy: 1103.74 },
        {cx: 868.063, cy: 1095.42 },
        {cx: 841.503, cy: 1086.67 },
        {cx: 815.073, cy: 1077.51 },
        {cx: 788.764, cy: 1067.94 },
        {cx: 762.573, cy: 1057.94 },
        {cx: 736.503, cy: 1047.53 },
        {cx: 710.554, cy: 1036.71 },
        {cx: 684.733, cy: 1025.47 },
        {cx: 659.034, cy: 1013.82 },
        {cx: 633.443, cy: 1001.76 },
        {cx: 607.983, cy: 989.28 },
        {cx: 582.644, cy: 976.4 }

      ]
    },
    //row D,
    {
      labelRow: "D",
      coordinates: [
        {cx: 2261.977, cy: 1020.942 },
        {cx: 2235.806, cy: 1033.956 },
        {cx: 2209.549, cy: 1046.574 },
        {cx: 2183.205, cy: 1058.792 },
        {cx: 2156.772, cy: 1070.607 },
        {cx: 2130.25, cy: 1082.016 },
        {cx: 2103.638, cy: 1093.015 },
        {cx: 2076.936, cy: 1103.6 },
        {cx: 2050.143, cy: 1113.769 },
        {cx: 2023.257, cy: 1123.517 },
        {cx: 1996.279, cy: 1132.842 },
        {cx: 1969.207, cy: 1141.739 },
        {cx: 1942.041, cy: 1150.205 },
        {cx: 1914.779, cy: 1158.238 },
        {cx: 1887.422, cy: 1165.832 },
        {cx: 1859.968, cy: 1172.986 },
        {cx: 1832.417, cy: 1179.695 },
        {cx: 1804.767, cy: 1185.956 },
        {cx: 1777.019, cy: 1191.765 },
        {cx: 1749.17, cy: 1197.119 },
        {cx: 1721.222, cy: 1202.016 },
        {cx: 1693.172, cy: 1206.449 },
        {cx: 1665.021, cy: 1210.418 },
        {cx: 1581.399, cy: 1219.776 },
        {cx: 1553.314, cy: 1222.01 },
        {cx: 1525.235, cy: 1223.875 },
        {cx: 1497.162, cy: 1225.361 },
        {cx: 1469.095, cy: 1226.455 },
        {cx: 1441.036, cy: 1227.147 },
        {cx: 1412.983, cy: 1227.427 },
        {cx: 1384.938, cy: 1227.28 },
        {cx: 1356.9, cy: 1226.697 },
        {cx: 1328.87, cy: 1225.667 },
        {cx: 1300.848, cy: 1224.178 },
        {cx: 1272.833, cy: 1222.218 },
        {cx: 1244.827, cy: 1219.776 },
        {cx: 1161.849, cy: 1210.418 },
        {cx: 1133.698, cy: 1206.449 },
        {cx: 1105.648, cy: 1202.016 },
        {cx: 1077.7, cy: 1197.12 },
        {cx: 1049.852, cy: 1191.766 },
        {cx: 1022.103, cy: 1185.956 },
        {cx: 994.454, cy: 1179.695 },
        {cx: 966.902, cy: 1172.986 },
        {cx: 939.449, cy: 1165.833 },
        {cx: 912.091, cy: 1158.238 },
        {cx: 884.83, cy: 1150.206 },
        {cx: 857.664, cy: 1141.739 },
        {cx: 830.591, cy: 1132.842 },
        {cx: 803.613, cy: 1123.517 },
        {cx: 776.728, cy: 1113.769 },
        {cx: 749.934, cy: 1103.601 },
        {cx: 723.232, cy: 1093.015 },
        {cx: 696.621, cy: 1082.016 },
        {cx: 670.099, cy: 1070.607 },
        {cx: 643.666, cy: 1058.792 },
        {cx: 617.321, cy: 1046.574 },
        {cx: 591.064, cy: 1033.956 },
        {cx: 564.894, cy: 1020.942 }

      ]
    },
,//row E,
    {
      labelRow: "E",
      coordinates: [
        {cx: 2277.725, cy: 1065.496 },
        {cx: 2252.777, cy: 1078.115 },
        {cx: 2227.69, cy: 1090.343 },
        {cx: 2202.466, cy: 1102.179 },
        {cx: 2177.105, cy: 1113.623 },
        {cx: 2151.608, cy: 1124.676 },
        {cx: 2125.977, cy: 1135.338 },
        {cx: 2100.211, cy: 1145.609 },
        {cx: 2074.313, cy: 1155.489 },
        {cx: 2048.284, cy: 1164.979 },
        {cx: 2022.124, cy: 1174.077 },
        {cx: 1995.833, cy: 1182.785 },
        {cx: 1969.415, cy: 1191.103 },
        {cx: 1942.868, cy: 1199.03 },
        {cx: 1916.195, cy: 1206.567 },
        {cx: 1889.396, cy: 1213.715 },
        {cx: 1862.472, cy: 1220.473 },
        {cx: 1835.425, cy: 1226.84 },
        {cx: 1808.254, cy: 1232.818 },
        {cx: 1780.963, cy: 1238.408 },
        {cx: 1753.55, cy: 1243.607 },
        {cx: 1726.018, cy: 1248.418 },
        {cx: 1698.367, cy: 1252.84 },
        {cx: 1670.598, cy: 1256.873 },
        {cx: 1586.84, cy: 1266.771 },
        {cx: 1557.81, cy: 1269.245 },
        {cx: 1528.807, cy: 1271.234 },
        {cx: 1499.83, cy: 1272.749 },
        {cx: 1470.877, cy: 1273.801 },
        {cx: 1441.95, cy: 1274.397 },
        {cx: 1413.047, cy: 1274.553 },
        {cx: 1384.168, cy: 1274.275 },
        {cx: 1355.312, cy: 1273.575 },
        {cx: 1326.478, cy: 1272.465 },
        {cx: 1297.665, cy: 1270.953 },
        {cx: 1268.874, cy: 1269.052 },
        {cx: 1240.103, cy: 1266.771 },
        {cx: 1156.272, cy: 1256.873 },
        {cx: 1128.503, cy: 1252.84 },
        {cx: 1100.853, cy: 1248.419 },
        {cx: 1073.32, cy: 1243.607 },
        {cx: 1045.907, cy: 1238.408 },
        {cx: 1018.616, cy: 1232.819 },
        {cx: 991.445, cy: 1226.841 },
        {cx: 964.398, cy: 1220.473 },
        {cx: 937.474, cy: 1213.715 },
        {cx: 910.675, cy: 1206.567 },
        {cx: 884.002, cy: 1199.03 },
        {cx: 857.456, cy: 1191.103 },
        {cx: 831.037, cy: 1182.785 },
        {cx: 804.747, cy: 1174.077 },
        {cx: 778.586, cy: 1164.979 },
        {cx: 752.557, cy: 1155.489 },
        {cx: 726.659, cy: 1145.609 },
        {cx: 700.894, cy: 1135.338 },
        {cx: 675.262, cy: 1124.676 },
        {cx: 649.765, cy: 1113.623 },
        {cx: 624.404, cy: 1102.179 },
        {cx: 599.18, cy: 1090.343 },
        {cx: 574.093, cy: 1078.115 },
        {cx: 549.145, cy: 1065.496 }

      ]
    },
    //row F,
    {
      labelRow: "F",
      coordinates: [
        {cx: 2293.439, cy: 1110.098 },
        {cx: 2267.95, cy: 1122.7 },
        {cx: 2242.344, cy: 1134.947 },
        {cx: 2216.622, cy: 1146.836 },
        {cx: 2190.78, cy: 1158.364 },
        {cx: 2164.82, cy: 1169.526 },
        {cx: 2138.739, cy: 1180.319 },
        {cx: 2112.536, cy: 1190.739 },
        {cx: 2086.211, cy: 1200.781 },
        {cx: 2059.763, cy: 1210.443 },
        {cx: 2033.191, cy: 1219.72 },
        {cx: 2006.494, cy: 1228.609 },
        {cx: 1979.67, cy: 1237.105 },
        {cx: 1952.719, cy: 1245.206 },
        {cx: 1925.64, cy: 1252.906 },
        {cx: 1898.433, cy: 1260.203 },
        {cx: 1871.095, cy: 1267.092 },
        {cx: 1843.626, cy: 1273.57 },
        {cx: 1816.026, cy: 1279.633 },
        {cx: 1788.293, cy: 1285.276 },
        {cx: 1760.426, cy: 1290.498 },
        {cx: 1732.424, cy: 1295.292 },
        {cx: 1704.287, cy: 1299.656 },
        {cx: 1676.013, cy: 1303.586 },
        {cx: 1592.461, cy: 1313.09 },
        {cx: 1564.907, cy: 1315.422 },
        {cx: 1537.349, cy: 1317.365 },
        {cx: 1509.786, cy: 1318.919 },
        {cx: 1482.218, cy: 1320.083 },
        {cx: 1454.647, cy: 1320.859 },
        {cx: 1427.071, cy: 1321.246 },
        {cx: 1399.49, cy: 1321.245 },
        {cx: 1371.904, cy: 1320.855 },
        {cx: 1344.314, cy: 1320.078 },
        {cx: 1316.72, cy: 1318.912 },
        {cx: 1289.121, cy: 1317.358 },
        {cx: 1261.518, cy: 1315.418 },
        {cx: 1233.91, cy: 1313.09 },
        {cx: 1150.857, cy: 1303.586 },
        {cx: 1122.583, cy: 1299.656 },
        {cx: 1094.446, cy: 1295.292 },
        {cx: 1066.444, cy: 1290.498 },
        {cx: 1038.578, cy: 1285.277 },
        {cx: 1010.844, cy: 1279.633 },
        {cx: 983.244, cy: 1273.57 },
        {cx: 955.775, cy: 1267.092 },
        {cx: 928.438, cy: 1260.203 },
        {cx: 901.23, cy: 1252.906 },
        {cx: 874.151, cy: 1245.206 },
        {cx: 847.201, cy: 1237.105 },
        {cx: 820.377, cy: 1228.609 },
        {cx: 793.679, cy: 1219.721 },
        {cx: 767.107, cy: 1210.443 },
        {cx: 740.659, cy: 1200.781 },
        {cx: 714.334, cy: 1190.739 },
        {cx: 688.132, cy: 1180.319 },
        {cx: 662.051, cy: 1169.526 },
        {cx: 636.09, cy: 1158.364 },
        {cx: 610.249, cy: 1146.836 },
        {cx: 584.526, cy: 1134.947 },
        {cx: 558.92, cy: 1122.7 },
        {cx: 533.432, cy: 1110.098 }

      ]
    },
    //row G,
    {
      labelRow: "G",
      coordinates: [
        {cx: 2309.617, cy: 1154.526 },
        {cx: 2284.648, cy: 1166.686 },
        {cx: 2259.584, cy: 1178.537 },
        {cx: 2234.424, cy: 1190.072 },
        {cx: 2209.166, cy: 1201.288 },
        {cx: 2183.807, cy: 1212.179 },
        {cx: 2158.348, cy: 1222.739 },
        {cx: 2132.787, cy: 1232.964 },
        {cx: 2107.121, cy: 1242.848 },
        {cx: 2081.348, cy: 1252.385 },
        {cx: 2055.468, cy: 1261.57 },
        {cx: 2029.48, cy: 1270.399 },
        {cx: 2003.38, cy: 1278.866 },
        {cx: 1977.169, cy: 1286.966 },
        {cx: 1950.844, cy: 1294.693 },
        {cx: 1924.404, cy: 1302.043 },
        {cx: 1897.846, cy: 1309.01 },
        {cx: 1871.17, cy: 1315.589 },
        {cx: 1844.375, cy: 1321.773 },
        {cx: 1817.458, cy: 1327.561 },
        {cx: 1790.417, cy: 1332.943 },
        {cx: 1763.251, cy: 1337.916 },
        {cx: 1735.959, cy: 1342.476 },
        {cx: 1708.541, cy: 1346.614 },
        {cx: 1680.992, cy: 1350.329 },
        {cx: 1597.527, cy: 1359.787 },
        {cx: 1569.199, cy: 1362.213 },
        {cx: 1540.869, cy: 1364.234 },
        {cx: 1512.535, cy: 1365.851 },
        {cx: 1484.199, cy: 1367.063 },
        {cx: 1455.859, cy: 1367.87 },
        {cx: 1427.517, cy: 1368.273 },
        {cx: 1399.171, cy: 1368.272 },
        {cx: 1370.823, cy: 1367.868 },
        {cx: 1342.471, cy: 1367.059 },
        {cx: 1314.117, cy: 1365.847 },
        {cx: 1285.759, cy: 1364.23 },
        {cx: 1257.398, cy: 1362.21 },
        {cx: 1229.035, cy: 1359.787 },
        {cx: 1145.878, cy: 1350.329 },
        {cx: 1118.33, cy: 1346.614 },
        {cx: 1090.91, cy: 1342.476 },
        {cx: 1063.619, cy: 1337.916 },
        {cx: 1036.454, cy: 1332.943 },
        {cx: 1009.413, cy: 1327.561 },
        {cx: 982.496, cy: 1321.773 },
        {cx: 955.7, cy: 1315.589 },
        {cx: 929.024, cy: 1309.011 },
        {cx: 902.467, cy: 1302.044 },
        {cx: 876.026, cy: 1294.693 },
        {cx: 849.701, cy: 1286.967 },
        {cx: 823.49, cy: 1278.866 },
        {cx: 797.39, cy: 1270.399 },
        {cx: 771.402, cy: 1261.57 },
        {cx: 745.522, cy: 1252.385 },
        {cx: 719.75, cy: 1242.848 },
        {cx: 694.084, cy: 1232.964 },
        {cx: 668.522, cy: 1222.739 },
        {cx: 643.063, cy: 1212.179 },
        {cx: 617.705, cy: 1201.289 },
        {cx: 592.446, cy: 1190.073 },
        {cx: 567.286, cy: 1178.537 },
        {cx: 542.222, cy: 1166.686 },
        {cx: 517.253, cy: 1154.526 }

      ]
    },
    //row H,
    {
      labelRow: "H",
      coordinates: [
        {cx: 2325.142, cy: 1198.706 },
        {cx: 2299.89, cy: 1211.11 },
        {cx: 2274.529, cy: 1223.174 },
        {cx: 2249.055, cy: 1234.894 },
        {cx: 2223.469, cy: 1246.267 },
        {cx: 2197.77, cy: 1257.291 },
        {cx: 2171.957, cy: 1267.962 },
        {cx: 2146.028, cy: 1278.279 },
        {cx: 2119.983, cy: 1288.239 },
        {cx: 2093.821, cy: 1297.839 },
        {cx: 2067.541, cy: 1307.075 },
        {cx: 2041.141, cy: 1315.947 },
        {cx: 2014.621, cy: 1324.45 },
        {cx: 1987.981, cy: 1332.582 },
        {cx: 1961.219, cy: 1340.342 },
        {cx: 1934.333, cy: 1347.725 },
        {cx: 1907.325, cy: 1354.728 },
        {cx: 1880.191, cy: 1361.35 },
        {cx: 1852.932, cy: 1367.588 },
        {cx: 1825.546, cy: 1373.439 },
        {cx: 1798.034, cy: 1378.9 },
        {cx: 1770.392, cy: 1383.97 },
        {cx: 1742.621, cy: 1388.644 },
        {cx: 1714.72, cy: 1392.92 },
        {cx: 1686.687, cy: 1396.796 },
        {cx: 1602.408, cy: 1406.254 },
        {cx: 1573.287, cy: 1408.763 },
        {cx: 1544.169, cy: 1410.854 },
        {cx: 1515.056, cy: 1412.526 },
        {cx: 1485.947, cy: 1413.781 },
        {cx: 1456.842, cy: 1414.617 },
        {cx: 1427.742, cy: 1415.036 },
        {cx: 1398.645, cy: 1415.036 },
        {cx: 1369.553, cy: 1414.618 },
        {cx: 1340.465, cy: 1413.782 },
        {cx: 1311.381, cy: 1412.527 },
        {cx: 1282.301, cy: 1410.854 },
        {cx: 1253.225, cy: 1408.764 },
        {cx: 1224.154, cy: 1406.254 },
        {cx: 1140.183, cy: 1396.796 },
        {cx: 1112.151, cy: 1392.92 },
        {cx: 1084.25, cy: 1388.644 },
        {cx: 1056.479, cy: 1383.97 },
        {cx: 1028.837, cy: 1378.9 },
        {cx: 1001.324, cy: 1373.439 },
        {cx: 973.938, cy: 1367.588 },
        {cx: 946.679, cy: 1361.351 },
        {cx: 919.545, cy: 1354.729 },
        {cx: 892.537, cy: 1347.725 },
        {cx: 865.652, cy: 1340.342 },
        {cx: 838.89, cy: 1332.583 },
        {cx: 812.249, cy: 1324.45 },
        {cx: 785.73, cy: 1315.947 },
        {cx: 759.33, cy: 1307.075 },
        {cx: 733.05, cy: 1297.839 },
        {cx: 706.888, cy: 1288.239 },
        {cx: 680.842, cy: 1278.279 },
        {cx: 654.914, cy: 1267.963 },
        {cx: 629.1, cy: 1257.291 },
        {cx: 603.401, cy: 1246.267 },
        {cx: 577.815, cy: 1234.894 },
        {cx: 552.342, cy: 1223.174 },
        {cx: 526.98, cy: 1211.11 },
        {cx: 501.729, cy: 1198.706 }

      ]
    },
    //row J,
    {
      labelRow: "J",
      coordinates: [
        {cx: 2341.247, cy: 1243.575 },
        {cx: 2315.468, cy: 1256.08 },
        {cx: 2289.581, cy: 1268.238 },
        {cx: 2263.582, cy: 1280.048 },
        {cx: 2237.474, cy: 1291.506 },
        {cx: 2211.255, cy: 1302.609 },
        {cx: 2184.927, cy: 1313.357 },
        {cx: 2158.488, cy: 1323.748 },
        {cx: 2131.94, cy: 1333.778 },
        {cx: 2105.281, cy: 1343.445 },
        {cx: 2078.512, cy: 1352.747 },
        {cx: 2051.633, cy: 1361.683 },
        {cx: 2024.644, cy: 1370.248 },
        {cx: 1997.544, cy: 1378.441 },
        {cx: 1970.335, cy: 1386.261 },
        {cx: 1943.015, cy: 1393.704 },
        {cx: 1915.585, cy: 1400.769 },
        {cx: 1888.045, cy: 1407.453 },
        {cx: 1860.396, cy: 1413.753 },
        {cx: 1832.635, cy: 1419.668 },
        {cx: 1804.764, cy: 1425.196 },
        {cx: 1776.784, cy: 1430.333 },
        {cx: 1748.693, cy: 1435.078 },
        {cx: 1720.492, cy: 1439.43 },
        {cx: 1692.18, cy: 1443.383 },
        {cx: 1608.284, cy: 1452.842 },
        {cx: 1580.426, cy: 1455.227 },
        {cx: 1552.569, cy: 1457.245 },
        {cx: 1524.711, cy: 1458.896 },
        {cx: 1496.854, cy: 1460.181 },
        {cx: 1468.996, cy: 1461.098 },
        {cx: 1441.138, cy: 1461.648 },
        {cx: 1413.281, cy: 1461.832 },
        {cx: 1385.423, cy: 1461.648 },
        {cx: 1357.566, cy: 1461.098 },
        {cx: 1329.708, cy: 1460.181 },
        {cx: 1301.851, cy: 1458.896 },
        {cx: 1273.993, cy: 1457.245 },
        {cx: 1246.136, cy: 1455.227 },
        {cx: 1218.278, cy: 1452.842 },
        {cx: 1134.69, cy: 1443.383 },
        {cx: 1106.378, cy: 1439.43 },
        {cx: 1078.177, cy: 1435.079 },
        {cx: 1050.086, cy: 1430.334 },
        {cx: 1022.106, cy: 1425.196 },
        {cx: 994.235, cy: 1419.669 },
        {cx: 966.475, cy: 1413.754 },
        {cx: 938.825, cy: 1407.453 },
        {cx: 911.285, cy: 1400.769 },
        {cx: 883.855, cy: 1393.704 },
        {cx: 856.536, cy: 1386.261 },
        {cx: 829.326, cy: 1378.441 },
        {cx: 802.227, cy: 1370.248 },
        {cx: 775.237, cy: 1361.683 },
        {cx: 748.358, cy: 1352.747 },
        {cx: 721.589, cy: 1343.445 },
        {cx: 694.931, cy: 1333.778 },
        {cx: 668.382, cy: 1323.748 },
        {cx: 641.943, cy: 1313.357 },
        {cx: 615.615, cy: 1302.609 },
        {cx: 589.396, cy: 1291.506 },
        {cx: 563.288, cy: 1280.048 },
        {cx: 537.29, cy: 1268.238 },
        {cx: 511.402, cy: 1256.08 },
        {cx: 485.624, cy: 1243.575 }

      ]
    },
    //row K: 28 ghế,
    {
      labelRow: "K",
      coordinates: [
        {cx: 1907.845, cy: 1522.986 },
        {cx: 1881.039, cy: 1528.994 },
        {cx: 1854.172, cy: 1534.653 },
        {cx: 1827.248, cy: 1539.968 },
        {cx: 1800.268, cy: 1544.939 },
        {cx: 1773.233, cy: 1549.57 },
        {cx: 1746.147, cy: 1553.864 },
        {cx: 1719.01, cy: 1557.822 },
        {cx: 1570.478, cy: 1574.99 },
        {cx: 1541.681, cy: 1576.88 },
        {cx: 1512.994, cy: 1578.431 },
        {cx: 1484.42, cy: 1579.631 },
        {cx: 1455.964, cy: 1580.468 },
        {cx: 1427.63, cy: 1580.927 },
        {cx: 1399.422, cy: 1580.997 },
        {cx: 1371.344, cy: 1580.664 },
        {cx: 1343.399, cy: 1579.917 },
        {cx: 1315.593, cy: 1578.74 },
        {cx: 1287.928, cy: 1577.123 },
        {cx: 1260.41, cy: 1575.052 },
        {cx: 1108.072, cy: 1557.822 },
        {cx: 1080.936, cy: 1553.864 },
        {cx: 1053.85, cy: 1549.57 },
        {cx: 1026.815, cy: 1544.939 },
        {cx: 999.835, cy: 1539.968 },
        {cx: 972.911, cy: 1534.653 },
        {cx: 946.044, cy: 1528.994 },
        {cx: 919.238, cy: 1522.986 }

      ]
    },
    //row L,
    {
      labelRow: "L",
      coordinates: [
        {cx: 2397.474, cy: 1399.084 },
        {cx: 2372.482, cy: 1410.969 },
        {cx: 2347.328, cy: 1422.604 },
        {cx: 2322.007, cy: 1433.985 },
        {cx: 2296.516, cy: 1445.107 },
        {cx: 2270.851, cy: 1455.963 },
        { cx: 2244.724, cy: 1466.55 },//ghe 7
        {cx: 2055.914, cy: 1532.245 },
        {cx: 2028.661, cy: 1540.096 },
        {cx: 2001.354, cy: 1547.646 },
        {cx: 1973.99, cy: 1554.885 },
        {cx: 1946.569, cy: 1561.802 },
        {cx: 1919.088, cy: 1568.389 },
        {cx: 1891.547, cy: 1574.635 },
        {cx: 1863.943, cy: 1580.531 },
        {cx: 1836.273, cy: 1586.067 },
        {cx: 1808.538, cy: 1591.233 },
        {cx: 1780.734, cy: 1596.021 },
        {cx: 1752.86, cy: 1600.417 },
        {cx: 1724.915, cy: 1604.416 },
        {cx: 1617.528, cy: 1617.205 },
        {cx: 1588.142, cy: 1619.497 },
        {cx: 1558.841, cy: 1621.439 },
        {cx: 1529.625, cy: 1623.032 },
        {cx: 1500.492, cy: 1624.273 },
        {cx: 1471.445, cy: 1625.162 },
        {cx: 1442.482, cy: 1625.699 },
        {cx: 1413.605, cy: 1625.883 },
        {cx: 1384.814, cy: 1625.711 },
        {cx: 1356.108, cy: 1625.186 },
        {cx: 1327.488, cy: 1624.304 },
        {cx: 1298.954, cy: 1623.065 },
        {cx: 1270.506, cy: 1621.471 },
        {cx: 1242.145, cy: 1619.518 },
        {cx: 1213.87, cy: 1617.205 },
        {cx: 1102.348, cy: 1604.416 },
        {cx: 1074.402, cy: 1600.417 },
        {cx: 1046.528, cy: 1596.021 },
        {cx: 1018.724, cy: 1591.233 },
        {cx: 990.989, cy: 1586.067 },
        {cx: 963.319, cy: 1580.531 },
        {cx: 935.715, cy: 1574.635 },
        {cx: 908.173, cy: 1568.389 },
        {cx: 880.693, cy: 1561.802 },
        {cx: 853.272, cy: 1554.885 },
        {cx: 825.909, cy: 1547.646 },
        {cx: 798.601, cy: 1540.096 },
        {cx: 771.348, cy: 1532.245 },
        {cx: 582.254, cy: 1466.548 },
        {cx: 556.412, cy: 1455.963 },
        {cx: 530.747, cy: 1445.107 },
        {cx: 505.255, cy: 1433.985 },
        {cx: 479.934, cy: 1422.604 },
        {cx: 454.779, cy: 1410.969 },
        {cx: 429.788, cy: 1399.084 }

      ]
    },    //row M,
    {
      labelRow: "M",
      coordinates: [
        {cx: 2413.295, cy: 1443.394 },
        {cx: 2388.173, cy: 1455.305 },
        {cx: 2362.946, cy: 1466.938 },
        {cx: 2337.61, cy: 1478.292 },
        {cx: 2312.165, cy: 1489.368 },
        {cx: 2286.609, cy: 1500.165 },
        { cx: 2260.653, cy: 1510.68 },//ghe 7
        {cx: 2071.288, cy: 1576.67 },
        {cx: 2043.312, cy: 1584.84 },
        {cx: 2015.262, cy: 1592.659 },
        {cx: 1987.139, cy: 1600.124 },
        {cx: 1958.94, cy: 1607.231 },
        {cx: 1930.667, cy: 1613.979 },
        {cx: 1902.317, cy: 1620.365 },
        {cx: 1873.892, cy: 1626.385 },
        {cx: 1845.389, cy: 1632.036 },
        {cx: 1816.808, cy: 1637.316 },
        {cx: 1788.149, cy: 1642.223 },
        {cx: 1759.412, cy: 1646.752 },
        {cx: 1730.595, cy: 1650.901 },
        {cx: 1623.345, cy: 1662.959 },
        {cx: 1593.298, cy: 1665.466 },
        {cx: 1563.268, cy: 1667.616 },
        {cx: 1533.265, cy: 1669.405 },
        {cx: 1503.3, cy: 1670.828 },
        {cx: 1473.385, cy: 1671.879 },
        {cx: 1443.529, cy: 1672.551 },
        {cx: 1413.743, cy: 1672.841 },
        {cx: 1384.038, cy: 1672.742 },
        {cx: 1354.424, cy: 1672.249 },
        {cx: 1324.914, cy: 1671.356 },
        {cx: 1295.516, cy: 1670.06 },
        {cx: 1266.242, cy: 1668.352 },
        {cx: 1237.102, cy: 1666.229 },
        {cx: 1208.107, cy: 1663.685 },
        {cx: 1096.667, cy: 1650.901 },
        {cx: 1067.85, cy: 1646.752 },
        {cx: 1039.112, cy: 1642.223 },
        {cx: 1010.454, cy: 1637.316 },
        {cx: 981.873, cy: 1632.036 },
        {cx: 953.37, cy: 1626.385 },
        {cx: 924.944, cy: 1620.365 },
        {cx: 896.595, cy: 1613.979 },
        {cx: 868.322, cy: 1607.231 },
        {cx: 840.124, cy: 1600.124 },
        {cx: 812, cy: 1592.659 },
        {cx: 783.951, cy: 1584.84 },
        {cx: 755.974, cy: 1576.67 },
        {cx: 566.321, cy: 1510.684 },
        {cx: 540.653, cy: 1500.165 },
        {cx: 515.097, cy: 1489.368 },
        {cx: 489.652, cy: 1478.292 },
        {cx: 464.316, cy: 1466.938 },
        {cx: 439.088, cy: 1455.305 },
        {cx: 413.967, cy: 1443.394 }

      ]
    },    //row N,
    {
      labelRow: "N",
      coordinates: [
        {cx: 2429.025, cy: 1487.729 },
        {cx: 2403.927, cy: 1499.641 },
        {cx: 2378.703, cy: 1511.245 },
        {cx: 2353.356, cy: 1522.555 },
        {cx: 2327.893, cy: 1533.58 },
        {cx: 2302.316, cy: 1544.332 },
        { cx: 2276.344, cy: 1554.82 },//ghe 7
        {cx: 2087.737, cy: 1620.611 },
        {cx: 2061.053, cy: 1628.497 },
        {cx: 2034.299, cy: 1636.053 },
        {cx: 2007.476, cy: 1643.278 },
        {cx: 1980.583, cy: 1650.174 },
        {cx: 1953.621, cy: 1656.74 },
        {cx: 1926.587, cy: 1662.976 },
        {cx: 1899.485, cy: 1668.882 },
        {cx: 1872.313, cy: 1674.458 },
        {cx: 1845.071, cy: 1679.704 },
        {cx: 1817.759, cy: 1684.62 },
        {cx: 1790.377, cy: 1689.206 },
        {cx: 1762.926, cy: 1693.462 },
        {cx: 1735.405, cy: 1697.388 },
        {cx: 1628.45, cy: 1709.58 },
        {cx: 1599.546, cy: 1712.125 },
        {cx: 1570.723, cy: 1714.313 },
        {cx: 1541.979, cy: 1716.145 },
        {cx: 1513.315, cy: 1717.618 },
        {cx: 1484.729, cy: 1718.734 },
        {cx: 1456.221, cy: 1719.494 },
        {cx: 1427.792, cy: 1719.897 },
        {cx: 1399.441, cy: 1719.943 },
        {cx: 1371.167, cy: 1719.633 },
        {cx: 1342.969, cy: 1718.965 },
        {cx: 1314.849, cy: 1717.94 },
        {cx: 1286.804, cy: 1716.559 },
        {cx: 1258.835, cy: 1714.821 },
        {cx: 1230.942, cy: 1712.727 },
        {cx: 1203.124, cy: 1710.275 },
        {cx: 1091.857, cy: 1697.388 },
        {cx: 1064.335, cy: 1693.462 },
        {cx: 1036.884, cy: 1689.206 },
        {cx: 1009.502, cy: 1684.62 },
        {cx: 982.191, cy: 1679.704 },
        {cx: 954.949, cy: 1674.458 },
        {cx: 927.777, cy: 1668.882 },
        {cx: 900.674, cy: 1662.976 },
        {cx: 873.642, cy: 1656.74 },
        {cx: 846.679, cy: 1650.174 },
        {cx: 819.786, cy: 1643.278 },
        {cx: 792.962, cy: 1636.053 },
        {cx: 766.209, cy: 1628.497 },
        {cx: 739.525, cy: 1620.611 },
        {cx: 550.63, cy: 1554.821 },
        {cx: 524.946, cy: 1544.332 },
        {cx: 499.369, cy: 1533.58 },
        {cx: 473.906, cy: 1522.555 },
        {cx: 448.56, cy: 1511.245 },
        {cx: 423.335, cy: 1499.641 },
        {cx: 398.237, cy: 1487.729 }

      ]
    },    //row P,
    {
      labelRow: "P",
      coordinates: [
        {cx: 2444.956, cy: 1532.183 },
        {cx: 2419.861, cy: 1544.082 },
        {cx: 2394.624, cy: 1555.669 },
        {cx: 2369.246, cy: 1566.947 },
        {cx: 2343.731, cy: 1577.922 },
        {cx: 2318.083, cy: 1588.598 },
        { cx: 2292.014, cy: 1598.98 },//ghe 7
        {cx: 2103.084, cy: 1664.991 },
        {cx: 2075.668, cy: 1673.059 },
        {cx: 2048.177, cy: 1680.795 },
        {cx: 2020.613, cy: 1688.202 },
        {cx: 1992.974, cy: 1695.279 },
        {cx: 1965.262, cy: 1702.027 },
        {cx: 1937.476, cy: 1708.444 },
        {cx: 1909.616, cy: 1714.532 },
        {cx: 1881.683, cy: 1720.29 },
        {cx: 1853.675, cy: 1725.718 },
        {cx: 1825.593, cy: 1730.815 },
        {cx: 1797.438, cy: 1735.583 },
        {cx: 1769.209, cy: 1740.021 },
        {cx: 1740.906, cy: 1744.129 },
        {cx: 1633.473, cy: 1756.242 },
        {cx: 1604.015, cy: 1758.641 },
        {cx: 1574.614, cy: 1760.732 },
        {cx: 1545.27, cy: 1762.511 },
        {cx: 1515.985, cy: 1763.969 },
        {cx: 1486.759, cy: 1765.1 },
        {cx: 1457.596, cy: 1765.897 },
        {cx: 1428.495, cy: 1766.354 },
        {cx: 1399.458, cy: 1766.465 },
        {cx: 1370.486, cy: 1766.221 },
        {cx: 1341.58, cy: 1765.617 },
        {cx: 1312.742, cy: 1764.646 },
        {cx: 1283.973, cy: 1763.299 },
        {cx: 1255.274, cy: 1761.572 },
        {cx: 1226.646, cy: 1759.458 },
        {cx: 1198.091, cy: 1756.948 },
        {cx: 1086.356, cy: 1744.129 },
        {cx: 1058.053, cy: 1740.021 },
        {cx: 1029.824, cy: 1735.583 },
        {cx: 1001.668, cy: 1730.815 },
        {cx: 973.587, cy: 1725.718 },
        {cx: 945.58, cy: 1720.29 },
        {cx: 917.646, cy: 1714.532 },
        {cx: 889.786, cy: 1708.444 },
        {cx: 862, cy: 1702.027 },
        {cx: 834.288, cy: 1695.279 },
        {cx: 806.649, cy: 1688.202 },
        {cx: 779.085, cy: 1680.795 },
        {cx: 751.594, cy: 1673.059 },
        {cx: 724.177, cy: 1664.991 },
        {cx: 534.959, cy: 1598.979 },
        {cx: 509.18, cy: 1588.598 },
        {cx: 483.531, cy: 1577.922 },
        {cx: 458.016, cy: 1566.947 },
        {cx: 432.639, cy: 1555.669 },
        {cx: 407.401, cy: 1544.082 },
        {cx: 382.306, cy: 1532.183 }

      ]
    },    //row Q,
    {
      labelRow: "Q",
      coordinates: [
        {cx: 2460.854, cy: 1576.551 },
        {cx: 2435.678, cy: 1588.37 },
        {cx: 2410.393, cy: 1599.902 },
        {cx: 2384.997, cy: 1611.146 },
        {cx: 2359.491, cy: 1622.104 },
        {cx: 2333.875, cy: 1632.773 },
        { cx: 2307.863, cy: 1643.16 },//ghe 7
        {cx: 2116.611, cy: 1709.853 },
        {cx: 2088.586, cy: 1718.048 },
        {cx: 2060.494, cy: 1725.946 },
        {cx: 2032.333, cy: 1733.538 },
        {cx: 2004.103, cy: 1740.815 },
        {cx: 1975.8, cy: 1747.77 },
        {cx: 1947.425, cy: 1754.392 },
        {cx: 1918.975, cy: 1760.673 },
        {cx: 1890.45, cy: 1766.604 },
        {cx: 1861.845, cy: 1772.177 },
        {cx: 1833.163, cy: 1777.382 },
        {cx: 1804.398, cy: 1782.211 },
        {cx: 1775.551, cy: 1786.655 },
        {cx: 1746.621, cy: 1790.706 },
        {cx: 1639.399, cy: 1802.649 },
        {cx: 1610.99, cy: 1805.166 },
        {cx: 1582.644, cy: 1807.345 },
        {cx: 1554.362, cy: 1809.187 },
        {cx: 1526.143, cy: 1810.694 },
        {cx: 1497.987, cy: 1811.868 },
        {cx: 1469.894, cy: 1812.713 },
        {cx: 1441.863, cy: 1813.229 },
        {cx: 1413.893, cy: 1813.419 },
        {cx: 1385.985, cy: 1813.285 },
        {cx: 1358.137, cy: 1812.829 },
        {cx: 1330.351, cy: 1812.054 },
        {cx: 1302.625, cy: 1810.961 },
        {cx: 1274.958, cy: 1809.552 },
        {cx: 1247.351, cy: 1807.83 },
        {cx: 1219.803, cy: 1805.797 },
        {cx: 1192.313, cy: 1803.454 },
        {cx: 1080.641, cy: 1790.706 },
        {cx: 1051.71, cy: 1786.655 },
        {cx: 1022.864, cy: 1782.211 },
        {cx: 994.1, cy: 1777.382 },
        {cx: 965.417, cy: 1772.177 },
        {cx: 936.813, cy: 1766.604 },
        {cx: 908.287, cy: 1760.673 },
        {cx: 879.836, cy: 1754.392 },
        {cx: 851.461, cy: 1747.77 },
        {cx: 823.16, cy: 1740.815 },
        {cx: 794.929, cy: 1733.538 },
        {cx: 766.768, cy: 1725.946 },
        {cx: 738.676, cy: 1718.048 },
        {cx: 710.651, cy: 1709.853 },
        {cx: 519.113, cy: 1643.156 },
        {cx: 493.387, cy: 1632.773 },
        {cx: 467.771, cy: 1622.104 },
        {cx: 442.265, cy: 1611.146 },
        {cx: 416.87, cy: 1599.902 },
        {cx: 391.583, cy: 1588.37 },
        {cx: 366.408, cy: 1576.551 }

      ]
    },    //row R,
    {
      labelRow: "R",
      coordinates: [
        {cx: 2476.617, cy: 1620.918 },
        {cx: 2451.47, cy: 1632.77 },
        {cx: 2426.191, cy: 1644.286 },
        {cx: 2400.785, cy: 1655.484 },
        {cx: 2375.259, cy: 1666.379 },
        {cx: 2349.62, cy: 1676.986 },
        { cx: 2323.584, cy: 1687.32 },//ghe 7
        {cx: 2134.371, cy: 1753.513 },
        {cx: 2107.834, cy: 1761.211 },
        {cx: 2080.801, cy: 1768.835 },
        {cx: 2053.713, cy: 1776.207 },
        {cx: 2026.568, cy: 1783.314 },
        {cx: 1999.362, cy: 1790.148 },
        {cx: 1972.094, cy: 1796.696 },
        {cx: 1944.761, cy: 1802.946 },
        {cx: 1917.36, cy: 1808.887 },
        {cx: 1889.889, cy: 1814.508 },
        {cx: 1862.346, cy: 1819.797 },
        {cx: 1834.728, cy: 1824.742 },
        {cx: 1807.032, cy: 1829.333 },
        {cx: 1779.256, cy: 1833.559 },
        {cx: 1751.399, cy: 1837.406 },
        {cx: 1644.47, cy: 1849.307 },
        {cx: 1615.497, cy: 1851.769 },
        {cx: 1586.574, cy: 1853.928 },
        {cx: 1557.703, cy: 1855.779 },
        {cx: 1528.882, cy: 1857.32 },
        {cx: 1500.115, cy: 1858.546 },
        {cx: 1471.4, cy: 1859.452 },
        {cx: 1442.739, cy: 1860.035 },
        {cx: 1414.132, cy: 1860.29 },
        {cx: 1385.581, cy: 1860.214 },
        {cx: 1357.085, cy: 1859.802 },
        {cx: 1328.646, cy: 1859.05 },
        {cx: 1300.264, cy: 1857.954 },
        {cx: 1271.939, cy: 1856.51 },
        {cx: 1243.673, cy: 1854.714 },
        {cx: 1215.467, cy: 1852.561 },
        {cx: 1187.32, cy: 1850.048 },
        {cx: 1075.864, cy: 1837.406 },
        {cx: 1048.005, cy: 1833.559 },
        {cx: 1020.23, cy: 1829.333 },
        {cx: 992.534, cy: 1824.742 },
        {cx: 964.916, cy: 1819.797 },
        {cx: 937.373, cy: 1814.508 },
        {cx: 909.902, cy: 1808.887 },
        {cx: 882.501, cy: 1802.946 },
        {cx: 855.168, cy: 1796.696 },
        {cx: 827.9, cy: 1790.148 },
        {cx: 800.694, cy: 1783.314 },
        {cx: 773.548, cy: 1776.207 },
        {cx: 746.46, cy: 1768.835 },
        {cx: 719.427, cy: 1761.211 },
        {cx: 692.447, cy: 1753.347 },
        {cx: 503.39, cy: 1687.32 },
        {cx: 477.642, cy: 1676.986 },
        {cx: 452.002, cy: 1666.379 },
        {cx: 426.477, cy: 1655.484 },
        {cx: 401.071, cy: 1644.286 },
        {cx: 375.792, cy: 1632.77 },
        {cx: 350.645, cy: 1620.918 }

      ]
    },    //row S,
    {
      labelRow: "S",
      coordinates: [
        {cx: 2492.424, cy: 1665.295 },
        {cx: 2467.294, cy: 1677.035 },
        {cx: 2442.027, cy: 1688.482 },
        {cx: 2416.628, cy: 1699.645 },
        {cx: 2391.101, cy: 1710.526 },
        {cx: 2365.45, cy: 1721.137 },
        { cx: 2339.394, cy: 1731.48 },//ghe 7
        {cx: 2150.042, cy: 1798.499 },
        {cx: 2122.592, cy: 1805.847 },
        {cx: 2094.86, cy: 1813.712 },
        {cx: 2067.071, cy: 1821.292 },
        {cx: 2039.221, cy: 1828.58 },
        {cx: 2011.312, cy: 1835.57 },
        {cx: 1983.339, cy: 1842.254 },
        {cx: 1955.303, cy: 1848.625 },
        {cx: 1927.202, cy: 1854.677 },
        {cx: 1899.034, cy: 1860.401 },
        {cx: 1870.799, cy: 1865.793 },
        {cx: 1842.495, cy: 1870.845 },
        {cx: 1814.119, cy: 1875.55 },
        {cx: 1785.671, cy: 1879.9 },
        {cx: 1757.15, cy: 1883.89 },
        {cx: 1650.411, cy: 1895.811 },
        {cx: 1620.595, cy: 1898.504 },
        {cx: 1590.857, cy: 1900.85 },
        {cx: 1561.193, cy: 1902.848 },
        {cx: 1531.601, cy: 1904.496 },
        {cx: 1502.08, cy: 1905.793 },
        {cx: 1472.628, cy: 1906.739 },
        {cx: 1443.244, cy: 1907.333 },
        {cx: 1413.924, cy: 1907.572 },
        {cx: 1384.669, cy: 1907.458 },
        {cx: 1355.476, cy: 1906.987 },
        {cx: 1326.343, cy: 1906.159 },
        {cx: 1297.268, cy: 1904.974 },
        {cx: 1268.25, cy: 1903.429 },
        {cx: 1239.287, cy: 1901.524 },
        {cx: 1210.376, cy: 1899.259 },
        {cx: 1181.518, cy: 1896.631 },
        {cx: 1070.112, cy: 1883.89 },
        {cx: 1041.591, cy: 1879.9 },
        {cx: 1013.143, cy: 1875.55 },
        {cx: 984.768, cy: 1870.845 },
        {cx: 956.463, cy: 1865.793 },
        {cx: 928.228, cy: 1860.401 },
        {cx: 900.06, cy: 1854.677 },
        {cx: 871.959, cy: 1848.625 },
        {cx: 843.923, cy: 1842.254 },
        {cx: 815.951, cy: 1835.57 },
        {cx: 788.041, cy: 1828.58 },
        {cx: 760.191, cy: 1821.292 },
        {cx: 732.402, cy: 1813.712 },
        {cx: 704.67, cy: 1805.847 },
        {cx: 676.995, cy: 1797.703 },
        {cx: 487.584, cy: 1731.48 },
        {cx: 461.813, cy: 1721.137 },
        {cx: 436.161, cy: 1710.526 },
        {cx: 410.634, cy: 1699.645 },
        {cx: 385.234, cy: 1688.482 },
        {cx: 359.968, cy: 1677.035 },
        {cx: 334.838, cy: 1665.295 }

      ]
    },    //row T,
    {
      labelRow: "T",
      coordinates: [
        {cx: 2508.303, cy: 1709.586 },
        {cx: 2483.121, cy: 1721.303 },
        {cx: 2457.818, cy: 1732.737 },
        {cx: 2432.394, cy: 1743.893 },
        {cx: 2406.852, cy: 1754.77 },
        {cx: 2381.19, cy: 1765.371 },
        { cx: 2355.123, cy: 1775.7 },//ghe 7
        {cx: 2166.525, cy: 1843.101 },
        {cx: 2139.587, cy: 1851.145 },
        {cx: 2113.339, cy: 1857.267 },
        {cx: 2086.664, cy: 1864.645 },
        {cx: 2059.928, cy: 1871.741 },
        {cx: 2033.134, cy: 1878.556 },
        {cx: 2006.281, cy: 1885.085 },
        {cx: 1979.368, cy: 1891.326 },
        {cx: 1952.394, cy: 1897.278 },
        {cx: 1925.36, cy: 1902.938 },
        {cx: 1898.264, cy: 1908.303 },
        {cx: 1871.107, cy: 1913.371 },
        {cx: 1843.887, cy: 1918.141 },
        {cx: 1816.605, cy: 1922.608 },
        {cx: 1789.259, cy: 1926.772 },
        {cx: 1761.85, cy: 1930.63 },
        {cx: 1655.545, cy: 1942.433 },
        {cx: 1626.863, cy: 1944.98 },
        {cx: 1598.243, cy: 1947.216 },
        {cx: 1569.686, cy: 1949.141 },
        {cx: 1541.192, cy: 1950.753 },
        {cx: 1512.76, cy: 1952.053 },
        {cx: 1484.392, cy: 1953.04 },
        {cx: 1456.086, cy: 1953.717 },
        {cx: 1427.843, cy: 1954.08 },
        {cx: 1399.664, cy: 1954.131 },
        {cx: 1371.546, cy: 1953.87 },
        {cx: 1343.492, cy: 1953.296 },
        {cx: 1315.501, cy: 1952.41 },
        {cx: 1287.573, cy: 1951.211 },
        {cx: 1259.708, cy: 1949.699 },
        {cx: 1231.905, cy: 1947.875 },
        {cx: 1204.166, cy: 1945.737 },
        {cx: 1176.49, cy: 1943.287 },
        {cx: 1065.412, cy: 1930.63 },
        {cx: 1038.003, cy: 1926.772 },
        {cx: 1010.657, cy: 1922.608 },
        {cx: 983.375, cy: 1918.141 },
        {cx: 956.155, cy: 1913.371 },
        {cx: 928.998, cy: 1908.303 },
        {cx: 901.902, cy: 1902.938 },
        {cx: 874.868, cy: 1897.278 },
        {cx: 847.895, cy: 1891.326 },
        {cx: 820.981, cy: 1885.085 },
        {cx: 794.128, cy: 1878.556 },
        {cx: 767.334, cy: 1871.741 },
        {cx: 740.599, cy: 1864.645 },
        {cx: 713.922, cy: 1857.267 },
        {cx: 687.304, cy: 1849.61 },
        {cx: 660.743, cy: 1841.679 },
        {cx: 471.851, cy: 1775.698 },
        {cx: 446.072, cy: 1765.371 },
        {cx: 420.41, cy: 1754.77 },
        {cx: 394.868, cy: 1743.893 },
        {cx: 369.444, cy: 1732.737 },
        {cx: 344.141, cy: 1721.303 },
        {cx: 318.959, cy: 1709.586 }

      ]
    },    //row U,
    {
      labelRow: "U",
      coordinates: [
        {cx: 2524.116, cy: 1753.976 },
        {cx: 2498.916, cy: 1765.618 },
        {cx: 2473.599, cy: 1777.001 },
        {cx: 2448.163, cy: 1788.118 },
        {cx: 2422.606, cy: 1798.967 },
        {cx: 2396.927, cy: 1809.542 },
        { cx: 2370.834, cy: 1819.84 },//ghe 7
        {cx: 2181.676, cy: 1888.208 },
        {cx: 2154.108, cy: 1896.39 },
        {cx: 2127.039, cy: 1902.025 },
        {cx: 2099.746, cy: 1909.562 },
        {cx: 2072.395, cy: 1916.824 },
        {cx: 2044.986, cy: 1923.808 },
        {cx: 2017.517, cy: 1930.508 },
        {cx: 1989.989, cy: 1936.918 },
        {cx: 1962.398, cy: 1943.034 },
        {cx: 1934.746, cy: 1948.85 },
        {cx: 1907.03, cy: 1954.361 },
        {cx: 1879.25, cy: 1959.562 },
        {cx: 1851.405, cy: 1964.446 },
        {cx: 1823.493, cy: 1969.011 },
        {cx: 1795.513, cy: 1973.248 },
        {cx: 1767.466, cy: 1977.155 },
        {cx: 1660.743, cy: 1988.973 },
        {cx: 1631.535, cy: 1991.451 },
        {cx: 1602.376, cy: 1993.649 },
        {cx: 1573.269, cy: 1995.562 },
        {cx: 1544.212, cy: 1997.185 },
        {cx: 1515.208, cy: 1998.513 },
        {cx: 1486.256, cy: 1999.542 },
        {cx: 1457.359, cy: 2000.269 },
        {cx: 1428.516, cy: 2000.687 },
        {cx: 1399.728, cy: 2000.791 },
        {cx: 1370.997, cy: 2000.579 },
        {cx: 1342.322, cy: 2000.045 },
        {cx: 1313.705, cy: 1999.185 },
        {cx: 1285.147, cy: 1997.992 },
        {cx: 1256.648, cy: 1996.465 },
        {cx: 1228.209, cy: 1994.597 },
        {cx: 1199.832, cy: 1992.384 },
        {cx: 1171.515, cy: 1989.821 },
        {cx: 1059.796, cy: 1977.155 },
        {cx: 1031.749, cy: 1973.248 },
        {cx: 1003.77, cy: 1969.011 },
        {cx: 975.857, cy: 1964.446 },
        {cx: 948.012, cy: 1959.562 },
        {cx: 920.232, cy: 1954.361 },
        {cx: 892.516, cy: 1948.85 },
        {cx: 864.864, cy: 1943.034 },
        {cx: 837.273, cy: 1936.918 },
        {cx: 809.745, cy: 1930.508 },
        {cx: 782.276, cy: 1923.808 },
        {cx: 754.867, cy: 1916.824 },
        {cx: 727.517, cy: 1909.562 },
        {cx: 700.223, cy: 1902.025 },
        {cx: 672.986, cy: 1894.222 },
        {cx: 645.804, cy: 1886.154 },
        {cx: 456.138, cy: 1819.842 },
        {cx: 430.335, cy: 1809.542 },
        {cx: 404.656, cy: 1798.967 },
        {cx: 379.1, cy: 1788.118 },
        {cx: 353.664, cy: 1777.001 },
        {cx: 328.346, cy: 1765.618 },
        {cx: 303.146, cy: 1753.976 }

      ]
    },    //row V
    {
      labelRow: "V",
      coordinates: [
        {cx: 2539.978, cy: 1798.335 },
        {cx: 2514.751, cy: 1809.967 },
        {cx: 2489.41, cy: 1821.33 },
        {cx: 2463.953, cy: 1832.422 },
        {cx: 2438.381, cy: 1843.242 },
        {cx: 2412.694, cy: 1853.79 },
        { cx: 2386.604, cy: 1864.06 },//ghe 7
        {cx: 2197.808, cy: 1933.002 },
        {cx: 2169.58, cy: 1938.77 },
        {cx: 2141.72, cy: 1946.879 },
        {cx: 2113.785, cy: 1954.653 },
        {cx: 2085.776, cy: 1962.099 },
        {cx: 2057.695, cy: 1969.22 },
        {cx: 2029.542, cy: 1976.021 },
        {cx: 2001.318, cy: 1982.508 },
        {cx: 1973.025, cy: 1988.684 },
        {cx: 1944.663, cy: 1994.555 },
        {cx: 1916.234, cy: 2000.125 },
        {cx: 1887.739, cy: 2005.4 },
        {cx: 1859.178, cy: 2010.385 },
        {cx: 1830.553, cy: 2015.083 },
        {cx: 1801.866, cy: 2019.5 },
        {cx: 1773.117, cy: 2023.641 },
        {cx: 1668.542, cy: 2036.052 },
        {cx: 1639.957, cy: 2038.513 },
        {cx: 1611.45, cy: 2040.683 },
        {cx: 1583.019, cy: 2042.562 },
        {cx: 1554.666, cy: 2044.151 },
        {cx: 1526.389, cy: 2045.452 },
        {cx: 1498.188, cy: 2046.465 },
        {cx: 1470.064, cy: 2047.189 },
        {cx: 1442.016, cy: 2047.628 },
        {cx: 1414.044, cy: 2047.78 },
        {cx: 1386.148, cy: 2047.647 },
        {cx: 1358.328, cy: 2047.23 },
        {cx: 1330.583, cy: 2046.529 },
        {cx: 1302.912, cy: 2045.546 },
        {cx: 1275.317, cy: 2044.28 },
        {cx: 1247.797, cy: 2042.733 },
        {cx: 1220.352, cy: 2040.906 },
        {cx: 1192.98, cy: 2038.799 },
        {cx: 1165.684, cy: 2036.412 },
        {cx: 1054.146, cy: 2023.641 },
        {cx: 1025.396, cy: 2019.5 },
        {cx: 996.708, cy: 2015.083 },
        {cx: 968.084, cy: 2010.385 },
        {cx: 939.523, cy: 2005.4 },
        {cx: 911.028, cy: 2000.125 },
        {cx: 882.599, cy: 1994.555 },
        {cx: 854.237, cy: 1988.684 },
        {cx: 825.944, cy: 1982.508 },
        {cx: 797.72, cy: 1976.021 },
        {cx: 769.567, cy: 1969.22 },
        {cx: 741.486, cy: 1962.099 },
        {cx: 713.477, cy: 1954.653 },
        {cx: 685.542, cy: 1946.879 },
        {cx: 657.682, cy: 1938.77 },
        {cx: 629.898, cy: 1930.321 },
        {cx: 440.371, cy: 1864.064 },
        {cx: 414.568, cy: 1853.79 },
        {cx: 388.88, cy: 1843.242 },
        {cx: 363.309, cy: 1832.422 },
        {cx: 337.853, cy: 1821.33 },
        {cx: 312.511, cy: 1809.967 },
        {cx: 287.284, cy: 1798.335 }

      ]
    },    //row W,
    {
      labelRow: "W",
      coordinates: [
        {cx: 2555.819, cy: 1842.671 },
        {cx: 2530.614, cy: 1854.231 },
        {cx: 2505.279, cy: 1865.535 },
        {cx: 2479.813, cy: 1876.584 },
        {cx: 2454.214, cy: 1887.374 },
        {cx: 2428.484, cy: 1897.906 },
        { cx: 2402.334, cy: 1908.18 },//ghe 7
        {cx: 2271.327, cy: 1955.798 },
        {cx: 2244.47, cy: 1964.565 },
        {cx: 2217.55, cy: 1973.058 },
        {cx: 2190.568, cy: 1981.272 },
        {cx: 2163.521, cy: 1989.21 },
        {cx: 2136.411, cy: 1996.868 },
        {cx: 2109.236, cy: 2004.245 },
        {cx: 2081.997, cy: 2011.34 },
        {cx: 2054.693, cy: 2018.151 },
        {cx: 2027.324, cy: 2024.678 },
        {cx: 1999.889, cy: 2030.919 },
        {cx: 1972.389, cy: 2036.872 },
        {cx: 1944.823, cy: 2042.537 },
        {cx: 1917.19, cy: 2047.912 },
        {cx: 1889.491, cy: 2052.995 },
        {cx: 1861.725, cy: 2057.786 },
        {cx: 1833.892, cy: 2062.282 },
        {cx: 1805.991, cy: 2066.483 },
        {cx: 1778.022, cy: 2070.389 },
        {cx: 1673.483, cy: 2083.033 },
        {cx: 1644.359, cy: 2085.536 },
        {cx: 1615.309, cy: 2087.744 },
        {cx: 1586.335, cy: 2089.657 },
        {cx: 1557.435, cy: 2091.275 },
        {cx: 1528.611, cy: 2092.599 },
        {cx: 1499.861, cy: 2093.627 },
        {cx: 1471.186, cy: 2094.359 },
        {cx: 1442.585, cy: 2094.798 },
        {cx: 1414.06, cy: 2094.941 },
        {cx: 1385.61, cy: 2094.79 },
        {cx: 1357.234, cy: 2094.344 },
        {cx: 1328.933, cy: 2093.602 },
        {cx: 1300.707, cy: 2092.565 },
        {cx: 1272.555, cy: 2091.234 },
        {cx: 1244.479, cy: 2089.608 },
        {cx: 1216.477, cy: 2087.687 },
        {cx: 1188.549, cy: 2085.471 },
        {cx: 1160.697, cy: 2082.96 },
        {cx: 1049.24, cy: 2070.389 },
        {cx: 1021.271, cy: 2066.483 },
        {cx: 993.37, cy: 2062.282 },
        {cx: 965.537, cy: 2057.786 },
        {cx: 937.771, cy: 2052.995 },
        {cx: 910.072, cy: 2047.912 },
        {cx: 882.439, cy: 2042.537 },
        {cx: 854.873, cy: 2036.872 },
        {cx: 827.373, cy: 2030.919 },
        {cx: 799.938, cy: 2024.678 },
        {cx: 772.569, cy: 2018.151 },
        {cx: 745.265, cy: 2011.34 },
        {cx: 718.026, cy: 2004.245 },
        {cx: 690.851, cy: 1996.868 },
        {cx: 663.741, cy: 1989.21 },
        {cx: 636.694, cy: 1981.272 },
        {cx: 609.711, cy: 1973.058 },
        {cx: 582.792, cy: 1964.565 },
        {cx: 555.935, cy: 1955.798 },
        {cx: 424.641, cy: 1908.18 },
        {cx: 398.778, cy: 1897.906 },
        {cx: 373.048, cy: 1887.374 },
        {cx: 347.45, cy: 1876.584 },
        {cx: 321.983, cy: 1865.535 },
        {cx: 296.647, cy: 1854.231 },
        {cx: 271.443, cy: 1842.671 }

      ]
    },    //row X,
    {
      labelRow: "X",
      coordinates: [
        {cx: 2570.942, cy: 1887.43 },
        {cx: 2544.033, cy: 1899.6 },
        {cx: 2517.027, cy: 1911.541 },
        {cx: 2489.915, cy: 1923.233 },
        {cx: 2462.688, cy: 1934.654 },
        {cx: 2435.335, cy: 1945.781 },
        {cx: 2407.849, cy: 1956.593 },
        {cx: 2380.219, cy: 1967.067 },
        {cx: 2300.416, cy: 1995.439 },
        {cx: 2273.77, cy: 2004.262 },
        {cx: 2247.064, cy: 2012.827 },
        {cx: 2220.296, cy: 2021.132 },
        {cx: 2193.466, cy: 2029.174 },
        {cx: 2166.574, cy: 2036.952 },
        {cx: 2139.619, cy: 2044.464 },
        {cx: 2112.599, cy: 2051.707 },
        {cx: 2085.517, cy: 2058.68 },
        {cx: 2058.369, cy: 2065.379 },
        {cx: 2031.157, cy: 2071.805 },
        {cx: 2003.878, cy: 2077.953 },
        {cx: 1976.535, cy: 2083.822 },
        {cx: 1949.125, cy: 2089.41 },
        {cx: 1921.647, cy: 2094.716 },
        {cx: 1894.102, cy: 2099.736 },
        {cx: 1866.489, cy: 2104.469 },
        {cx: 1838.807, cy: 2108.913 },
        {cx: 1811.057, cy: 2113.065 },
        {cx: 1783.238, cy: 2116.924 },
        {cx: 1677.438, cy: 2129.751 },
        {cx: 1648.04, cy: 2132.271 },
        {cx: 1618.68, cy: 2134.491 },
        {cx: 1589.36, cy: 2136.411 },
        {cx: 1560.08, cy: 2138.031 },
        {cx: 1530.84, cy: 2139.353 },
        {cx: 1501.644, cy: 2140.376 },
        {cx: 1472.491, cy: 2141.102 },
        {cx: 1443.383, cy: 2141.53 },
        {cx: 1414.32, cy: 2141.662 },
        {cx: 1385.303, cy: 2141.497 },
        {cx: 1356.334, cy: 2141.037 },
        {cx: 1327.415, cy: 2140.281 },
        {cx: 1298.544, cy: 2139.231 },
        {cx: 1269.724, cy: 2137.888 },
        {cx: 1240.957, cy: 2136.25 },
        {cx: 1212.241, cy: 2134.319 },
        {cx: 1183.58, cy: 2132.096 },
        {cx: 1154.974, cy: 2129.58 },
        {cx: 1044.024, cy: 2116.924 },
        {cx: 1016.205, cy: 2113.065 },
        {cx: 988.455, cy: 2108.913 },
        {cx: 960.773, cy: 2104.469 },
        {cx: 933.16, cy: 2099.736 },
        {cx: 905.615, cy: 2094.716 },
        {cx: 878.138, cy: 2089.41 },
        {cx: 850.728, cy: 2083.822 },
        {cx: 823.383, cy: 2077.953 },
        {cx: 796.105, cy: 2071.805 },
        {cx: 768.893, cy: 2065.379 },
        {cx: 741.746, cy: 2058.68 },
        {cx: 714.663, cy: 2051.707 },
        {cx: 687.644, cy: 2044.464 },
        {cx: 660.688, cy: 2036.952 },
        {cx: 633.796, cy: 2029.174 },
        {cx: 606.966, cy: 2021.132 },
        {cx: 580.198, cy: 2012.827 },
        {cx: 553.492, cy: 2004.262 },
        {cx: 526.847, cy: 1995.439 },
        {cx: 447.042, cy: 1967.067 },
        {cx: 419.413, cy: 1956.593 },
        {cx: 391.926, cy: 1945.781 },
        {cx: 364.574, cy: 1934.654 },
        {cx: 337.347, cy: 1923.233 },
        {cx: 310.235, cy: 1911.541 },
        {cx: 283.229, cy: 1899.6 },
        {cx: 256.32, cy: 1887.43 }

      ]
    },    //row Y,
    {
      labelRow: "Y",
      coordinates: [
        {cx: 2586.708, cy: 1931.633 },
        {cx: 2559.804, cy: 1943.809 },
        {cx: 2532.8, cy: 1955.743 },
        {cx: 2505.688, cy: 1967.422 },
        {cx: 2478.46, cy: 1978.828 },
        {cx: 2451.111, cy: 1989.946 },
        {cx: 2423.632, cy: 2000.761 },
        {cx: 2396.017, cy: 2011.257 },
        {cx: 2315.887, cy: 2039.765 },
        {cx: 2288.726, cy: 2048.77 },
        {cx: 2261.502, cy: 2057.507 },
        {cx: 2234.216, cy: 2065.974 },
        {cx: 2206.869, cy: 2074.169 },
        {cx: 2179.457, cy: 2082.09 },
        {cx: 2151.983, cy: 2089.737 },
        {cx: 2124.444, cy: 2097.108 },
        {cx: 2096.842, cy: 2104.201 },
        {cx: 2069.175, cy: 2111.015 },
        {cx: 2041.443, cy: 2117.547 },
        {cx: 2013.647, cy: 2123.797 },
        {cx: 1985.785, cy: 2129.763 },
        {cx: 1957.856, cy: 2135.442 },
        {cx: 1929.862, cy: 2140.836 },
        {cx: 1901.801, cy: 2145.94 },
        {cx: 1873.673, cy: 2150.755 },
        {cx: 1845.479, cy: 2155.276 },
        {cx: 1817.216, cy: 2159.506 },
        {cx: 1788.885, cy: 2163.44 },
        {cx: 1683.782, cy: 2174.647 },
        {cx: 1655.202, cy: 2177.265 },
        {cx: 1626.672, cy: 2179.61 },
        {cx: 1598.196, cy: 2181.683 },
        {cx: 1569.771, cy: 2183.479 },
        {cx: 1541.399, cy: 2185 },
        {cx: 1513.08, cy: 2186.241 },
        {cx: 1484.814, cy: 2187.202 },
        {cx: 1456.603, cy: 2187.88 },
        {cx: 1428.445, cy: 2188.273 },
        {cx: 1400.342, cy: 2188.381 },
        {cx: 1372.294, cy: 2188.199 },
        {cx: 1344.302, cy: 2187.728 },
        {cx: 1316.365, cy: 2186.964 },
        {cx: 1288.485, cy: 2185.906 },
        {cx: 1260.661, cy: 2184.554 },
        {cx: 1232.894, cy: 2182.902 },
        {cx: 1205.184, cy: 2180.952 },
        {cx: 1177.532, cy: 2178.7 },
        {cx: 1149.938, cy: 2176.145 },
        {cx: 1038.377, cy: 2163.44 },
        {cx: 1010.046, cy: 2159.506 },
        {cx: 981.784, cy: 2155.276 },
        {cx: 953.588, cy: 2150.755 },
        {cx: 925.46, cy: 2145.94 },
        {cx: 897.4, cy: 2140.836 },
        {cx: 869.406, cy: 2135.442 },
        {cx: 841.478, cy: 2129.763 },
        {cx: 813.615, cy: 2123.797 },
        {cx: 785.819, cy: 2117.547 },
        {cx: 758.087, cy: 2111.015 },
        {cx: 730.42, cy: 2104.201 },
        {cx: 702.818, cy: 2097.108 },
        {cx: 675.279, cy: 2089.737 },
        {cx: 647.805, cy: 2082.09 },
        {cx: 620.394, cy: 2074.169 },
        {cx: 593.045, cy: 2065.974 },
        {cx: 565.76, cy: 2057.507 },
        {cx: 538.536, cy: 2048.77 },
        {cx: 511.375, cy: 2039.765 },
        {cx: 431.245, cy: 2011.257 },
        {cx: 403.63, cy: 2000.761 },
        {cx: 376.151, cy: 1989.946 },
        {cx: 348.802, cy: 1978.828 },
        {cx: 321.574, cy: 1967.422 },
        {cx: 294.462, cy: 1955.743 },
        {cx: 267.458, cy: 1943.809 },
        {cx: 240.555, cy: 1931.633 }

      ]
    },    //row Z,
    {
      labelRow: "Z",
      coordinates: [
        {cx: 2602.513, cy: 1976.013 },
        {cx: 2575.587, cy: 1988.151 },
        {cx: 2548.562, cy: 2000.048 },
        {cx: 2521.429, cy: 2011.685 },
        {cx: 2494.182, cy: 2023.042 },
        {cx: 2466.812, cy: 2034.104 },
        {cx: 2439.312, cy: 2044.853 },
        {cx: 2411.675, cy: 2055.269 },
        {cx: 2331.955, cy: 2083.741 },
        {cx: 2305.615, cy: 2092.486 },
        {cx: 2279.219, cy: 2100.992 },
        {cx: 2252.766, cy: 2109.254 },
        {cx: 2226.254, cy: 2117.271 },
        {cx: 2199.686, cy: 2125.04 },
        {cx: 2173.058, cy: 2132.559 },
        {cx: 2146.371, cy: 2139.825 },
        {cx: 2119.623, cy: 2146.835 },
        {cx: 2092.815, cy: 2153.587 },
        {cx: 2065.946, cy: 2160.079 },
        {cx: 2039.014, cy: 2166.308 },
        {cx: 2012.021, cy: 2172.27 },
        {cx: 1984.964, cy: 2177.965 },
        {cx: 1957.843, cy: 2183.388 },
        {cx: 1930.659, cy: 2188.538 },
        {cx: 1903.409, cy: 2193.412 },
        {cx: 1876.094, cy: 2198.009 },
        {cx: 1848.713, cy: 2202.323 },
        {cx: 1821.265, cy: 2206.354 },
        {cx: 1793.75, cy: 2210.1 },
        {cx: 1688.423, cy: 2223.603 },
        {cx: 1659.34, cy: 2225.945 },
        {cx: 1630.31, cy: 2228.024 },
        {cx: 1601.333, cy: 2229.839 },
        {cx: 1572.408, cy: 2231.389 },
        {cx: 1543.536, cy: 2232.674 },
        {cx: 1514.716, cy: 2233.694 },
        {cx: 1485.949, cy: 2234.45 },
        {cx: 1457.235, cy: 2234.94 },
        {cx: 1428.574, cy: 2235.165 },
        {cx: 1399.965, cy: 2235.124 },
        {cx: 1371.409, cy: 2234.816 },
        {cx: 1342.906, cy: 2234.243 },
        {cx: 1314.457, cy: 2233.404 },
        {cx: 1286.06, cy: 2232.298 },
        {cx: 1257.716, cy: 2230.925 },
        {cx: 1229.425, cy: 2229.284 },
        {cx: 1201.188, cy: 2227.377 },
        {cx: 1173.003, cy: 2225.202 },
        {cx: 1144.872, cy: 2222.76 },
        {cx: 1033.512, cy: 2210.1 },
        {cx: 1005.997, cy: 2206.354 },
        {cx: 978.549, cy: 2202.323 },
        {cx: 951.168, cy: 2198.009 },
        {cx: 923.853, cy: 2193.412 },
        {cx: 896.603, cy: 2188.538 },
        {cx: 869.418, cy: 2183.388 },
        {cx: 842.298, cy: 2177.965 },
        {cx: 815.242, cy: 2172.27 },
        {cx: 788.248, cy: 2166.308 },
        {cx: 761.316, cy: 2160.079 },
        {cx: 734.447, cy: 2153.587 },
        {cx: 707.639, cy: 2146.835 },
        {cx: 680.892, cy: 2139.825 },
        {cx: 654.204, cy: 2132.559 },
        {cx: 627.576, cy: 2125.04 },
        {cx: 601.007, cy: 2117.271 },
        {cx: 574.496, cy: 2109.254 },
        {cx: 548.043, cy: 2100.992 },
        {cx: 521.647, cy: 2092.486 },
        {cx: 495.307, cy: 2083.741 },
        {cx: 415.586, cy: 2055.269 },
        {cx: 387.95, cy: 2044.853 },
        {cx: 360.45, cy: 2034.104 },
        {cx: 333.081, cy: 2023.042 },
        {cx: 305.833, cy: 2011.685 },
        {cx: 278.7, cy: 2000.048 },
        {cx: 251.674, cy: 1988.151 },
        {cx: 224.749, cy: 1976.013 }

      ]
    },    //row AA,
    {
      labelRow: "AA",
      coordinates: [
        {cx: 2618.33, cy: 2020.323 },
        {cx: 2591.385, cy: 2032.483 },
        {cx: 2564.339, cy: 2044.382 },
        {cx: 2537.187, cy: 2056.004 },
        {cx: 2509.922, cy: 2067.336 },
        {cx: 2482.541, cy: 2078.363 },
        {cx: 2455.037, cy: 2089.071 },
        {cx: 2427.404, cy: 2099.448 },
        {cx: 2347.549, cy: 2127.964 },
        {cx: 2320.731, cy: 2136.944 },
        {cx: 2293.85, cy: 2145.655 },
        {cx: 2266.907, cy: 2154.098 },
        {cx: 2239.901, cy: 2162.271 },
        {cx: 2212.833, cy: 2170.175 },
        {cx: 2185.702, cy: 2177.811 },
        {cx: 2158.509, cy: 2185.178 },
        {cx: 2131.254, cy: 2192.276 },
        {cx: 2103.937, cy: 2199.108 },
        {cx: 2076.557, cy: 2205.672 },
        {cx: 2049.116, cy: 2211.968 },
        {cx: 2021.612, cy: 2217.996 },
        {cx: 1994.046, cy: 2223.757 },
        {cx: 1966.418, cy: 2229.251 },
        {cx: 1938.729, cy: 2234.479 },
        {cx: 1910.978, cy: 2239.439 },
        {cx: 1883.165, cy: 2244.133 },
        {cx: 1855.29, cy: 2248.562 },
        {cx: 1827.353, cy: 2252.723 },
        {cx: 1799.354, cy: 2256.619 },
        {cx: 1692.352, cy: 2269.514 },
        {cx: 1662.862, cy: 2271.891 },
        {cx: 1633.41, cy: 2274.033 },
        {cx: 1603.997, cy: 2275.935 },
        {cx: 1574.623, cy: 2277.591 },
        {cx: 1545.29, cy: 2278.996 },
        {cx: 1515.996, cy: 2280.146 },
        {cx: 1486.744, cy: 2281.032 },
        {cx: 1457.533, cy: 2281.651 },
        {cx: 1428.365, cy: 2281.999 },
        {cx: 1399.239, cy: 2282.068 },
        {cx: 1370.156, cy: 2281.854 },
        {cx: 1341.118, cy: 2281.351 },
        {cx: 1312.124, cy: 2280.554 },
        {cx: 1283.174, cy: 2279.457 },
        {cx: 1254.271, cy: 2278.056 },
        {cx: 1225.413, cy: 2276.344 },
        {cx: 1196.602, cy: 2274.316 },
        {cx: 1167.838, cy: 2271.968 },
        {cx: 1139.122, cy: 2269.293 },
        {cx: 1027.908, cy: 2256.619 },
        {cx: 999.909, cy: 2252.723 },
        {cx: 971.972, cy: 2248.562 },
        {cx: 944.097, cy: 2244.133 },
        {cx: 916.284, cy: 2239.439 },
        {cx: 888.533, cy: 2234.479 },
        {cx: 860.843, cy: 2229.251 },
        {cx: 833.215, cy: 2223.757 },
        {cx: 805.65, cy: 2217.996 },
        {cx: 778.146, cy: 2211.968 },
        {cx: 750.705, cy: 2205.672 },
        {cx: 723.325, cy: 2199.108 },
        {cx: 696.008, cy: 2192.276 },
        {cx: 668.753, cy: 2185.178 },
        {cx: 641.56, cy: 2177.811 },
        {cx: 614.43, cy: 2170.175 },
        {cx: 587.361, cy: 2162.271 },
        {cx: 560.355, cy: 2154.098 },
        {cx: 533.412, cy: 2145.655 },
        {cx: 506.531, cy: 2136.944 },
        {cx: 479.713, cy: 2127.964 },
        {cx: 399.858, cy: 2099.448 },
        {cx: 372.226, cy: 2089.071 },
        {cx: 344.721, cy: 2078.363 },
        {cx: 317.339, cy: 2067.336 },
        {cx: 290.075, cy: 2056.004 },
        {cx: 262.923, cy: 2044.382 },
        {cx: 235.877, cy: 2032.483 },
        {cx: 208.933, cy: 2020.323 }

      ]
    },    //row BB,
    {
      labelRow: "BB",
      coordinates: [
        {cx: 2634.088, cy: 2064.64 },
        {cx: 2607.155, cy: 2076.718 },
        {cx: 2580.124, cy: 2088.563 },
        {cx: 2552.988, cy: 2100.155 },
        {cx: 2525.741, cy: 2111.477 },
        {cx: 2498.374, cy: 2122.507 },
        {cx: 2470.881, cy: 2133.227 },
        {cx: 2443.254, cy: 2143.617 },
        {cx: 2362.851, cy: 2172.484 },
        {cx: 2337.99, cy: 2181.139 },
        {cx: 2312.796, cy: 2189.559 },
        {cx: 2287.272, cy: 2197.743 },
        {cx: 2261.421, cy: 2205.697 },
        {cx: 2235.246, cy: 2213.42 },
        {cx: 2208.748, cy: 2220.916 },
        {cx: 2181.931, cy: 2228.187 },
        {cx: 2154.799, cy: 2235.233 },
        {cx: 2127.354, cy: 2242.059 },
        {cx: 2099.598, cy: 2248.664 },
        {cx: 2071.536, cy: 2255.052 },
        {cx: 2043.168, cy: 2261.225 },
        {cx: 2014.5, cy: 2267.184 },
        {cx: 1985.531, cy: 2272.932 },
        {cx: 1956.268, cy: 2278.47 },
        {cx: 1926.71, cy: 2283.801 },
        {cx: 1896.864, cy: 2288.927 },
        {cx: 1866.729, cy: 2293.85 },
        {cx: 1836.31, cy: 2298.571 },
        {cx: 1805.61, cy: 2303.094 },
        {cx: 1698.039, cy: 2314.775 },
        {cx: 1669.517, cy: 2317.495 },
        {cx: 1641.032, cy: 2319.92 },
        {cx: 1612.583, cy: 2322.051 },
        {cx: 1584.169, cy: 2323.892 },
        {cx: 1555.791, cy: 2325.444 },
        {cx: 1527.447, cy: 2326.712 },
        {cx: 1499.137, cy: 2327.697 },
        {cx: 1470.862, cy: 2328.402 },
        {cx: 1442.622, cy: 2328.83 },
        {cx: 1414.415, cy: 2328.982 },
        {cx: 1386.241, cy: 2328.863 },
        {cx: 1358.101, cy: 2328.474 },
        {cx: 1329.994, cy: 2327.816 },
        {cx: 1301.919, cy: 2326.896 },
        {cx: 1273.877, cy: 2325.712 },
        {cx: 1245.867, cy: 2324.269 },
        {cx: 1217.889, cy: 2322.569 },
        {cx: 1189.943, cy: 2320.614 },
        {cx: 1162.028, cy: 2318.409 },
        {cx: 1134.144, cy: 2315.953 },
        {cx: 1021.652, cy: 2303.094 },
        {cx: 990.952, cy: 2298.571 },
        {cx: 960.533, cy: 2293.85 },
        {cx: 930.398, cy: 2288.927 },
        {cx: 900.551, cy: 2283.801 },
        {cx: 870.995, cy: 2278.47 },
        {cx: 841.731, cy: 2272.932 },
        {cx: 812.763, cy: 2267.184 },
        {cx: 784.094, cy: 2261.225 },
        {cx: 755.727, cy: 2255.052 },
        {cx: 727.664, cy: 2248.664 },
        {cx: 699.908, cy: 2242.059 },
        {cx: 672.463, cy: 2235.233 },
        {cx: 645.331, cy: 2228.187 },
        {cx: 618.514, cy: 2220.916 },
        {cx: 592.017, cy: 2213.42 },
        {cx: 565.841, cy: 2205.697 },
        {cx: 539.99, cy: 2197.743 },
        {cx: 514.465, cy: 2189.559 },
        {cx: 489.272, cy: 2181.139 },
        {cx: 464.411, cy: 2172.484 },
        {cx: 384.008, cy: 2143.617 },
        {cx: 356.381, cy: 2133.227 },
        {cx: 328.888, cy: 2122.507 },
        {cx: 301.521, cy: 2111.477 },
        {cx: 274.274, cy: 2100.155 },
        {cx: 247.138, cy: 2088.563 },
        {cx: 220.107, cy: 2076.718 },
        {cx: 193.174, cy: 2064.64 }

      ]
    }
];